import request from '@/service/request'
export default class getPhoneService {
  /**
   * 获取加密手机号
   * @param data
   * @param data.key
   * @param data.code  code=001 查寄件手机号 002收件手机号 003 下单人手机号
   **/
  static getPhone(data: any): Promise<any> {
    return request.post('/sensitive/decrypt', data) 
  }
}
